import type { Dispatch } from 'redux';
import flow from 'lodash/flow';
import ReduxAnalyticsData from '@atlassian/jira-analytics-web-react/src/components/redux-analytics-data.tsx';
import type { Item } from '@atlassian/jira-navigation-apps-common/src/compontents/switcher/model/index.tsx';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import {
	fetchInitialBoards,
	itemClicked,
	changeSearch,
	loadMore,
	retry,
	type Action,
} from '../state/actions.tsx';
import {
	getViewAllUrl,
	isLoading,
	isLoadingMore,
	getSearchValue,
	isSearchUsed,
	isError,
	shouldRetryLoadMore,
} from '../state/selectors.tsx';
import type { State } from '../state/types.tsx';
import {
	getOtherBoards,
	getSelectedBoard,
	getRecentBoards,
	getBoardsInLocation,
	hasShowMoreButton,
	getRemainingShowMoreBoards,
} from './selectors.tsx';
import ScopeSwitcherV2 from './view.tsx';

const mapStateToProps = (state: State) => ({
	boardsInLocation: getBoardsInLocation(state),
	otherBoards: getOtherBoards(state),
	selectedBoard: getSelectedBoard(state),
	isLoading: isLoading(state),
	isLoadingMore: isLoadingMore(state),
	viewAllUrl: getViewAllUrl(state),
	searchValue: getSearchValue(state),
	isError: isError(state),
	isSearchUsed: isSearchUsed(state),
	hasShowMoreButton: hasShowMoreButton(state),
	shouldRetryLoadMore: shouldRetryLoadMore(state),
	remainingShowMoreBoards: getRemainingShowMoreBoards(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
	fetchInitialBoards: () => {
		dispatch(fetchInitialBoards());
	},
	searchBoards: (value: string) => {
		dispatch(changeSearch(value));
	},
	loadMore: () => {
		dispatch(loadMore());
	},
	onClick: ({ isViewAll, key }: Item) => {
		dispatch(itemClicked({ isViewAll: !!isViewAll, id: key }));
	},
	onRetry: () => {
		dispatch(retry());
	},
});

export default flow(
	ReduxAnalyticsData((state) => ({
		attributes: {
			recentBoards: getRecentBoards(state).length,
			boardsInLocation: getBoardsInLocation(state).length,
			searchUsed: isSearchUsed(state),
		},
	})),
	connect(mapStateToProps, mapDispatchToProps),
)(
	// @ts-expect-error - Argument of type 'ComponentType<WithIntlProps<Pick<Props, "intl" | "locationName" | "viewAllUrl" | "boardsInLocation" | "otherBoards"> & InexactPartial<Pick<Props, "isLoading" | "onClick" | "defaultOpen" | ... 13 more ... | "hasCreateBoardButton">> & InexactPartial<...>>>' is not assignable to parameter of type 'ComponentType<unknown>'. | Argument of type 'ComponentType<WithIntlProps<Pick<Props, "intl" | "viewAllUrl" | "boardsInLocation" | "locationName" | "otherBoards"> & InexactPartial<Pick<Props, "isLoading" | "onClick" | "searchValue" | ... 13 more ... | "hasCreateBoardButton">> & InexactPartial<...>>>' is not assignable to parameter of type 'ComponentType<unknown>'.
	ScopeSwitcherV2,
);
